import { Navigate, useParams, useSearch } from '@tanstack/react-router';

import { CreativeEditorPage } from '../../campaigns/creatives/components/CreativeEditor/CreativeEditorPage';
import { CreativeEditorMode, CreativeTab } from '../../campaigns/creatives/model';
import { AgencyCampaignSection, AgencyEditorMode } from '../model';
import { opensAgencyEditor } from './agencyEditorRoute';

/** Creative editor for the agency workspace; unsupported editor states return to the list. */
export function AgencyCreativeEditorContent() {
  const { agencyId } = useParams({ from: '/a/$agencyId_/campaigns/$section' });
  const routeSearch = useSearch({ from: '/a/$agencyId_/campaigns/$section' });
  const brandId = routeSearch.brand ?? '';
  const creativeTab = routeSearch.creativeTab ?? CreativeTab.Display;
  if (opensAgencyEditor(routeSearch.editor, routeSearch.id))
    return (
      <CreativeEditorPage
        key={`${agencyId}:${brandId}:${creativeTab}:${routeSearch.id ?? 'new'}`}
        tab={creativeTab}
        mode={
          routeSearch.editor === AgencyEditorMode.Edit
            ? CreativeEditorMode.Edit
            : CreativeEditorMode.Create
        }
        brandId={brandId}
        creativeId={routeSearch.id}
      />
    );
  return (
    <Navigate
      to="/a/$agencyId/campaigns/$section"
      params={{ agencyId, section: AgencyCampaignSection.Creatives }}
      search={{ brand: brandId, creativeTab }}
      replace
    />
  );
}
